import { StyledMiniLeaderboard } from './styled'

export const MiniLeaderboardAdSlot = () => {
  return (
    <StyledMiniLeaderboard
      id="gpt-minileaderboard-base"
      data-testid="mini-leaderboard"
      key="mini-leaderboard"
    />
  )
}
